import React, { useState } from 'react';
import { login } from '../api';
import { Check, Eye, EyeOff, ArrowRight } from './trading/public-site/icons';
import logoLight from '../assets/logo/logo-light.svg';
import logoDark from '../assets/logo/logo-dark.svg';
import './AuthPage.css';

// Вхід до бектестингу — той самий дизайн, що й вхід у торгового бота
// (Login.js + AuthPage.css), але без реєстрації, Google і відновлення паролю:
// акаунти бектестингу заводить адміністратор.

const ASIDE_BULLETS = [
  'Перевірка стратегій на історії акцій США з 2020 року',
  'Реалізм: ліквідність, делістинги, архівна капіталізація',
  'Перебір сотень тисяч комбінацій параметрів',
];

function Field({ id, label, children }) {
  return (
    <div className="auth-field">
      <label className="auth-field__label" htmlFor={id}>{label}</label>
      <div className="auth-field__control">{children}</div>
    </div>
  );
}

export default function CalcLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [showPw,   setShowPw]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Бекенд приймає логін або email в одному полі (identifier).
      const res = await login({ username: username.trim(), password });
      onLogin(res.data.token, res.data.username, res.data.role || 'user');
    } catch (err) {
      setError(err.response?.data?.detail || 'Помилка — перевір підключення до сервера');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth">
      <aside className="auth__aside">
        <div className="auth__aside-grid" aria-hidden="true" />
        <div className="auth__aside-inner">
          <div className="auth__aside-brand">
            <img src={logoLight} alt="Trading.com.ua" height={34} />
          </div>
          <div className="auth__aside-copy">
            <h2 className="auth__aside-title">
              Бектестинг<br />торгових стратегій
            </h2>
            <ul className="auth__aside-list">
              {ASIDE_BULLETS.map((b) => (
                <li key={b}>
                  <span className="auth__aside-check">
                    <Check size={14} />
                  </span>
                  {b}
                </li>
              ))}
            </ul>
          </div>
          <p className="auth__aside-note">
            Доступ до платформи надає адміністратор. Якщо у вас немає акаунту — зверніться до нього.
          </p>
        </div>
      </aside>

      <main className="auth__main">
        <div className="auth__card">
          <div className="auth__topbar">
            <span className="auth__brand-mobile">
              <img src={logoDark} alt="Trading.com.ua" height={30} />
            </span>
          </div>

          <div className="auth__head">
            <h1 className="auth__title">Вхід до бектестингу</h1>
            <p className="auth__subtitle">Введіть дані для входу</p>
          </div>

          <form className="auth__form" onSubmit={handleSubmit} noValidate>
            <Field id="calc-username" label="Логін або email">
              <input id="calc-username" className="auth-input" type="text" value={username}
                onChange={e => setUsername(e.target.value)} placeholder="username"
                autoComplete="username" autoFocus required />
            </Field>

            <Field id="calc-password" label="Пароль">
              <input id="calc-password" className="auth-input" type={showPw ? 'text' : 'password'}
                value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"
                autoComplete="current-password" required />
              <button type="button" className="auth-input__toggle" onClick={() => setShowPw(s => !s)}
                aria-label={showPw ? 'Приховати пароль' : 'Показати пароль'}>
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </Field>

            {error && <div className="auth__banner auth__banner--error">{error}</div>}

            <button type="submit" className="auth__submit" disabled={loading}>
              {loading ? 'Зачекайте…' : 'Увійти'}
              {!loading && <ArrowRight size={18} />}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
